module.exports = __webpack_public_path__ + "img/newyork_presbyterian.5c28aaa5.png";